export default __webpack_public_path__ + "static/media/mastercard1.3c242ef7.svg";